import { useQuery } from "@tanstack/react-query";

import { processStepCatalogQuery } from "#modules/quoteRequestLines/infra/processStepCatalogQuery";
import { MaterialGradeType } from "shared";

export const useProcessStepCatalog = (materialGrade?: MaterialGradeType) => {
  const { data, ...rest } = useQuery(processStepCatalogQuery(materialGrade));

  return { processStepCatalog: data ?? [], ...rest };
};
